export const OFFER_PREVIEW = {
  OFFER_3: {
    installments: [
      {
        amount: '116.6600000000',
        capital: '116.6600000000',
        collection_cost: '0.0000000000',
        cost: '0.0000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-06-09T14:55:51.132424-05:00',
        taxes: '0.0000000000',
      },
      {
        amount: '116.6600000000',
        capital: '116.6600000000',
        collection_cost: '0.0000000000',
        cost: '0.0000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-07-09T14:55:51.132424-05:00',
        taxes: '0.0000000000',
      },
      {
        amount: '116.6600000000',
        capital: '116.6600000000',
        collection_cost: '0.0000000000',
        cost: '0.0000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-08-09T14:55:51.132424-05:00',
        taxes: '0.0000000000',
      },
    ],
    details: {
      tea: '0.0000000000',
      tcea: '0.0000000000',
      total_interest: '0.0000000000',
      total_taxes: '0.0000000000',
      total_costs: '0.0000000000',
      total_amount: '349.9800000000',
      total_remaining: '0.0000000000',
      downpayment: '0.0000000000',
      downpayment_amount: '0.0000000000',
    },
  },
  OFFER_6: {
    installments: [
      {
        amount: '65.9400000000',
        capital: '58.3300000000',
        collection_cost: '0.0000000000',
        cost: '6.4500000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-06-09T14:55:51.245916-05:00',
        taxes: '1.1600000000',
      },
      {
        amount: '65.9400000000',
        capital: '58.3300000000',
        collection_cost: '0.0000000000',
        cost: '6.4500000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-07-09T14:55:51.245916-05:00',
        taxes: '1.1600000000',
      },
      {
        amount: '65.9400000000',
        capital: '58.3300000000',
        collection_cost: '0.0000000000',
        cost: '6.4500000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-08-09T14:55:51.245916-05:00',
        taxes: '1.1600000000',
      },
      {
        amount: '65.9400000000',
        capital: '58.3300000000',
        collection_cost: '0.0000000000',
        cost: '6.4500000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-09-09T14:55:51.245916-05:00',
        taxes: '1.1600000000',
      },
      {
        amount: '65.9400000000',
        capital: '58.3300000000',
        collection_cost: '0.0000000000',
        cost: '6.4500000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-10-09T14:55:51.245916-05:00',
        taxes: '1.1600000000',
      },
      {
        amount: '65.9400000000',
        capital: '58.3300000000',
        collection_cost: '0.0000000000',
        cost: '6.4500000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-11-09T14:55:51.245916-05:00',
        taxes: '1.1600000000',
      },
    ],
    details: {
      tea: '0.0000000000',
      tcea: '82.9400000000',
      total_interest: '0.0000000000',
      total_taxes: '6.9600000000',
      total_costs: '38.7000000000',
      total_amount: '395.6400000000',
      total_remaining: '0.0000000000',
      downpayment: '0.0000000000',
      downpayment_amount: '0.0000000000',
    },
  },
  OFFER_12: {
    installments: [
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-06-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-07-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-08-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-09-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-10-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-11-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2023-12-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2024-01-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2024-02-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2024-03-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2024-04-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
      {
        amount: '36.4800000000',
        capital: '29.1600000000',
        collection_cost: '0.0000000000',
        cost: '6.2000000000',
        default_interest: '0.0000000000',
        interest: '0.0000000000',
        interest_rate: '0.0000000000',
        payday: '2024-05-09T14:55:51.286701-05:00',
        taxes: '1.1200000000',
      },
    ],
    details: {
      tea: '0.0000000000',
      tcea: '66.5400000000',
      total_interest: '0.0000000000',
      total_taxes: '13.4400000000',
      total_costs: '74.4000000000',
      total_amount: '437.7600000000',
      total_remaining: '0.0000000000',
      downpayment: '0.0000000000',
      downpayment_amount: '0.0000000000',
    },
  },
};
